import React from 'react';
export function Footer() {
  return <footer className="bg-forest-900 py-12 px-4 border-t border-forest-800" data-id="element-29">
      <div className="max-w-6xl mx-auto text-center space-y-6" data-id="element-30">
        <h3 className="font-serif text-2xl font-bold text-gold-500/50" data-id="element-31">
          Plantas Mexicanas
        </h3>

        <p className="text-cream-300/40 text-sm max-w-2xl mx-auto leading-relaxed" data-id="element-32">
          Descargo de responsabilidad: Este producto es meramente informativo y
          educativo. No pretende diagnosticar, tratar, curar o prevenir ninguna
          enfermedad. El uso de plantas medicinales es responsabilidad de quien
          las consume. Consulta siempre a tu médico antes de cambiar
          tratamientos o iniciar nuevos protocolos, especialmente si tomas
          medicamentos, estás embarazada o tienes condiciones médicas
          preexistentes.
        </p>

        <div className="pt-8 text-xs text-cream-300/20" data-id="element-33">
          &copy; {new Date().getFullYear()} Plantas Mexicanas para Dormir
          Profundo. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}